import React from "react";
import styled from "styled-components";
import { read_legacy_activity_value } from "./legacy_activity_formatting";

const TimelineLegacyChanges = styled.div`
    display: grid;
    gap: 0.35rem;
    min-width: 0;
`;

const TimelineLegacyChange = styled.div`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0.35rem 0.5rem;
    min-width: 0;
    color: ${p => p.theme.color};

    span {
        color: inherit;
        font-family: "fontMedium", sans-serif;
        font-size: 1.35rem;
        line-height: 1.5;
        overflow-wrap: anywhere;
        white-space: pre-wrap;
    }
`;

const TimelineLegacyPreviousValue = styled.span`
    color: var(--greyDark) !important;
`;

const TimelineLegacyChangeArrow = styled.span`
    color: ${p => p.theme.mid} !important;
`;

const legacyFieldLabels = {
    firstName: "First name",
    lastName: "Last name",
    phone: "Phone",
    phones: "Phone numbers",
    email: "Email",
    emails: "Email addresses",
    category: "Category",
    subcategory: "Subcategory",
    location: "Location"
};

// Retains useful field labels while keeping Brand, status and seller changes compact.
export const Timeline_Legacy_Activity_Changes = (props) => {
    const changes = props.event?.changes || [];

    return (
        <TimelineLegacyChanges>
            {changes.map(([field, from, to], index) => {
                const compact = ["brand", "brandname", "name", "internalname", "status", "seller", "caller", "contractseller"].includes(`${field}`.toLowerCase());

                return (
                    <TimelineLegacyChange key={`${field}-${index}`}>
                        {!compact && <span>{props.t(legacyFieldLabels[field] || field)}:</span>}
                        <TimelineLegacyPreviousValue>{read_legacy_activity_value(from)}</TimelineLegacyPreviousValue>
                        <TimelineLegacyChangeArrow aria-hidden="true">→</TimelineLegacyChangeArrow>
                        <span>{read_legacy_activity_value(to)}</span>
                    </TimelineLegacyChange>
                );
            })}
        </TimelineLegacyChanges>
    );
};
